// src/components/atoms/Panel.js
import React from 'react';
import './Panel.css';

/**
 * Panel – ein Container mit vordefiniertem Styling.
 *
 * @param {object} props - Die Component-Properties.
 * @param {React.ReactNode} props.children - Beliebige Inhalte, die innerhalb des Panels angezeigt werden.
 */
const Panel = ({ children, className = '', ...props }) => {
  return (
    <div className={`panel ${className}`} {...props}>
      {children}
    </div>
  );
};

export default Panel;
